import { Injectable } from '@angular/core';
import {
  AddEmailAddressContent,
  LoginFormValidate,
  OverlayMessage
} from '@com-delta-idp/mnx-login-ui';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginModalContent } from '../../models/aem';
import { error } from '../../models/reset-password-api.interface';
import { AddEmailAddressBaseFacadeService } from './add-email-address-base-facade.service';

@Injectable({
  providedIn: 'root'
})
export class AddEmailAddressHelperFacadeService extends AddEmailAddressBaseFacadeService {
  aemContent!: LoginModalContent;
  unsubscribe$ = new Subject();
  addEmailAddressContent$ = new BehaviorSubject<AddEmailAddressContent | null>(
    null
  );

  getAddEmailAddressContent(): AddEmailAddressContent {
    return this.addEmailAddressContent$.value || ({} as AddEmailAddressContent);
  }

  addEmailAddressFormFocusChange(fieldName: string) {
    LoginFormValidate.touchControlAddEmailAddress(
      fieldName,
      this.getAddEmailAddressContent()
    );
    this.getAddEmailAddressContent().formGroup.controls[
      'confirmEmail'
    ]?.updateValueAndValidity();
  }

  addEmailAddressFormValueChange(): void {
    this.getAddEmailAddressContent()
      .formGroup.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.getAddEmailAddressContent().formAttributes.errorCount =
          LoginFormValidate.validateFormFields(
            this.getAddEmailAddressContent().formGroup
          );
        this.getAddEmailAddressContent().formAttributes.errorAlertBanner =
          LoginFormValidate.getErrorAlert(
            this.getAddEmailAddressContent().formGroup
          );
      });
  }

  showHideOverylayMessage(value: OverlayMessage): void {
    this.getAddEmailAddressContent().isSuccess = value.isSuccess;
    this.getAddEmailAddressContent().isError = value.isError;
  }

  disableActionButton(value: boolean): void {
    this.getAddEmailAddressContent().formAttributes.disableActionButton = value;
  }

  handleError(errors: error[] | undefined): void {
    this.getAddEmailAddressContent().message =
      this.loginHelperUtils.getErrorMessageFromAem(
        this.aemContent,
        errors !== undefined ? `ERROR_MSG_${errors[0]?.code}` : null
      );
    this.showHideOverylayMessage({ isSuccess: false, isError: true });
  }

  resetForm(): void {
    this.getAddEmailAddressContent().formAttributes =
      this.helperService.getFormAttributes();
    this.showHideOverylayMessage({ isSuccess: false, isError: false });
    this.getAddEmailAddressContent().message = '';
    this.getAddEmailAddressContent().formGroup?.reset();
  }
}
